import { CheckCircleIcon, ChefHatIcon, Icon, TimerIcon } from '@phosphor-icons/react'

import { OrderStatusBarStatus } from './order-status-bar.types'

export const orderStatusBarIconsMap: Record<OrderStatusBarStatus, Icon> = {
  awaiting_pickup: CheckCircleIcon,
  in_progress: ChefHatIcon,
  new: TimerIcon,
}
